import request from '@/request'
const part_url = '/train/web/lecturer/';

function getTeacherList(trainLecturer) {
    console.log("数据12345+++++",trainLecturer);
    let url = part_url + "lecturerlist";
    return request.get(url,trainLecturer)
}


function getTeacherShouYeList(trainLecturer) {
    console.log("数据12345+++++",trainLecturer);
    let url = part_url + "lecturerSylist";
    return request.get(url,trainLecturer)
}


function getTeacherPageList(trainLecturer) {
    let url = part_url + "list";
    return request.get(url, {trainLecturer})
}



function getTeacherDetail(id) {
    let url = part_url + "getById";;
    return request.get(url, {id})
}


export default {
    getTeacherList,
    getTeacherDetail,
    getTeacherPageList,
    getTeacherShouYeList
}


// WEBPACK FOOTER //
// ./src/api/lecturer.js